module.exports = "<span class=gmw-vault-logo> <gmw-flag country=getVaultInfo().countryCode ng-if=\"!hideFlag && getVaultInfo().countryCode\"> </gmw-flag> <svg class=gmw-vault-logo__custodian ng-if=getVaultInfo().icon ng-style=getVaultInfo().icon.style> <use ng-attr-xlink:href=\"{{getVaultInfo().icon.id}}\" xlink:href=\"\"></use> </svg> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/vaults/directives/vault-logo/vault-logo.html
// module id = 826
// module chunks = 0